import React, { useState, useEffect } from 'react'
import './css/popular.css'
import Item from './Item'
import ItemSkeleton from '../skeletons/Item'

const Popular = () => {

    const [popular, setPopular] = useState([]);
    const [loading, setLoading] = useState(true);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        const fetchData = async () => {
            const res = await fetch(`${backendUrl}/popular-women`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json'
                }
            });
            const data = await res.json();
            if (data.success) {
                setPopular(data.products);
                setLoading(false);
            }
        };
        fetchData();
    }, [backendUrl])

    return (
        <div className='popular'>
            <h1>POPULAR IN WOMEN</h1>
            <hr />
            <div className="popular-item">
                {loading ? (
                    <ItemSkeleton />
                ) : popular.length > 0 ? (
                    popular.map((item, i) => (
                        <Item
                            key={i}
                            id={item._id}
                            image={item.primaryImage}
                            name={item.name}
                            new_price={item.new_price}
                            old_price={item.old_price}
                        />
                    ))
                ) : (
                    <p className="no-products">No popular products found.</p>
                )}
            </div>
        </div>
    )
}

export default Popular